import { useEffect, useState } from "react";
import { useAuth } from "../../lib/auth";
import { useIntl } from "../../lib/i18n";
import { apiJSON } from "../../lib/api";

type AuditRecord = {
  id: number;
  actorSub?: string;
  action: string;
  entity: string;
  entityId?: string;
  ts: string;
};

export default function AuditLogPage() {
  const { session } = useAuth();
  const { t } = useIntl();
  const [rows, setRows] = useState<AuditRecord[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!session) return;
    apiJSON<AuditRecord[]>("/api/v1/tenant/audit?limit=100", { token: session.token })
      .then(setRows)
      .catch((e) => setError(String(e.message ?? "fetch failed")));
  }, [session]);

  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("audit.title")}</h1>
      {error && <p className="mt-4 text-sm text-rose-600">{error}</p>}
      <div className="mt-6 overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-slate-200">
        <table className="min-w-full divide-y divide-slate-200 text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-4 py-2">{t("audit.timestamp")}</th>
              <th className="px-4 py-2">{t("audit.actor")}</th>
              <th className="px-4 py-2">{t("audit.action")}</th>
              <th className="px-4 py-2">{t("audit.entity")}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.map((r) => (
              <tr key={r.id}>
                <td className="px-4 py-2 text-slate-500">{new Date(r.ts).toLocaleString()}</td>
                <td className="px-4 py-2">{r.actorSub ?? "—"}</td>
                <td className="px-4 py-2">{r.action}</td>
                <td className="px-4 py-2 text-slate-600">
                  {r.entity}
                  {r.entityId ? ` · ${r.entityId.slice(0, 8)}…` : ""}
                </td>
              </tr>
            ))}
            {rows.length === 0 && !error && (
              <tr>
                <td colSpan={4} className="px-4 py-6 text-center text-slate-500">
                  No events recorded.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
